import React from 'react';
import Create from 'containers/rest/Create';
import Form from '../components/Form';

const BannersCreate = props => (
  <Create {...props} resource="banners">
    <Form />
  </Create>
);

BannersCreate.propTypes = {};

export default BannersCreate;
